import { flexColumn } from '@anm/styles/helpers';
import styled from 'styled-components';

const ModalContent = styled.div`
  ${flexColumn};
`;

export default ModalContent;
